{
    "translation": {
        "invoices": {
            "note": "Hyvä asiakas, jos maksat kortilla, ole hyvä ja jätä tämä lasku huomiotta."
        },
        "flowPicker": {
            "title": "Oletko uusi vai nykyinen Flex-asiakas?",
            "newCustomer": "Haluan liittyä Flex-asiakkaaksi",
            "existingCustomer": "Minulla on jo Flex-tilaus",
            "nextButton": "Jatka"
        },
        "lisaAnd": {
            "plans": {
                "selectSubscription": "Valitse tilaus",
                "description": "",
                "VALUE": {
                    "title": "Flex 36 kuukautta",
                    "description": "Vaihda tai lopeta 36 kk:n jälkeen"
                },
                "FLEX": {
                    "title": "Täysi joustavuus",
                    "description": "Vaihda tai lopeta milloin haluat",
                    "priceDescription": "{{months}} kk, jonka jälkeen {{price}}"
                },
                "disclaimer": "Hinta koskee hyväksyttyä Trade in ilmoitetussa kunnossa.",
                "welcomeMessage": {
                    "title": "",
                    "paragraphs": [
                        "Samsung Flex on Samsungin ja Lisa&:n yhteistyössä tarjoama palvelu, jonka avulla voit vuokrata Samsungin tuotteita Lisa&:ltä. Samsung Flexiin sovelletaan sekä Samsungin että Lisa&:n omia ehtoja."
                    ]
                }
            },
            "cart": {
                "priceFor": "{{price}} \nfor {{months}} months",
                "monthlyCost": "Kuukausikustannuksesi",
                "accessories": "Lisävarusteet",
                "prepayToday": "Tänään maksettava summa",
                "prepayTodayDisclaimer": "{{months}} kuukausi + Lisävarusteet",
                "showDiscount": "Näytä alennustiedot",
                "VALUE": {
                    "planName": "Flex 36 kuukautta"
                },
                "FLEX": {
                    "planName": "Täysi joustavuus"
                },
                "totalMonthlyDiscount": "<0>Kuukausialennus yhteensä (1-{{months}}) <1></1></0>",
                "totalMonthlyDiscountIncludesBoth": "<0>Sisältää alustavan vaihtoarvon ja alennuksesi.</0>"
            }
        },
        "general": {
            "readMore": "Lue lisää",
            "images_zero": "",
            "images_one": "1 kuva",
            "images_other": "{{count}} kuvaa",
            "edit": "Muokata",
            "cancel": "Keskeytä",
            "save": "Tallenna",
            "close": "Sulje",
            "view": "Katsella",
            "back": "Takaisin",
            "errors": {
                "required": "Tämä kenttä pitää täyttää"
            }
        },
        "svea": {
            "genericDiscount": "Alennus",
            "tradeinSubsidy": "Päivitetty vaihtoarvo Foxway-sertifioidun luokituksen jälkeen",
            "tradeinSubsidyPlaceholderReversal": "Trade-in -allenus säätö",
            "tradeinName": "Trade-in -alennus",
            "upfrontPaymentProduct": "Veloitettu: ",
            "upfrontPaymentProductDiscount": "Veloitettu: ",
            "upfrontPaymentTradeInDiscount": "Veloitettu: ",
            "reversal": "Peruutus: "
        },
        "header": {
            "back": "Takaisin",
            "backLink": "https://shop.samsung.com/fi/cart",
            "help": "Jos sinulla on kysyttävää, soita numeroon 080 077 31 77",
            "helpLink": "Matkapuhelin: 080 077 31 77",
            "toggleLabel": "Menu",
            "home": "Koti",
            "login": "Kirjaudu Samsung Flex -tilillesi",
            "loginSubtitle": "Valitse kirjautumistapa",
            "loginButton": "Kirjaudu sisään",
            "logOut": "Kirjaudu ulos",
            "subscriptions": "Omat laitteeni",
            "invoices": "Laskut",
            "offers": "Tarjoukset",
            "account": "Tilini",
            "language": {
                "options": {
                    "fi-FI": "Finnish",
                    "sv-SE": "Swedish",
                    "no-NO": "Norwegian",
                    "nb-NO": "Norwegian",
                    "da-DK": "Danish"
                },
                "label": "Valitse kieli",
                "labelDescription": "Valitse kieli jatkaaksesi",
                "selectLabel": "Kielen valitsin"
            }
        },
        "banner": {
            "title": "Uusi tapa käyttää Samsung Galaxya",
            "subTitle": "Intohimona tekniikka, huolta pitäen"
        },
        "footer": {
            "language": "",
            "languageLink": "",
            "backToTop": "Takaisin alkuun",
            "topNote": {
                "text": "Kysymyksissä ohjelmasta tai asiakaspalvelun kanssa keskustellessasi, ota ystävällisesti yhteyttä Samsung -yhtiöön numerossa 080 077 31 77.",
                "button": {
                    "text": "Soita asiakastukeen 080 077 31 77",
                    "url": "tel:080 077 31 77"
                }
            },
            "copyright": "Copyright© 1995-{{currentYear}} Samsung. Kaikki oikeudet pidätetään.",
            "termsAndConditions": "Katso täydelliset <1>ehdot</1>",
            "termsAndConditionsLink": "https://resellers.foxway.com/subscriptionterms-fi",
            "social": {
                "title": "Seuraa meitä",
                "items": []
            },
            "terms": [],
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "080 077 31 77",
                            "url": "tel:080 077 31 77"
                        },
                        {
                            "text": "ma-pe | 08:00 - 21:00"
                        },
                        {
                            "text": "la | Suljettu"
                        },
                        {
                            "text": "su | Suljettu"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/fi/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Tietoja Samsung Flexistä",
                    "text": "Lisa& tarjoaa yksityishenkilöille mahdollisuuden vuokrata tuotteita, joita Samsung Electronics Nordic AB tarjoaa Samsung Flex -palvelun puitteissa. Tilauksen yhteydessä asiakas voi myös ostaa tiettyjä muita tuotteita Lisa&:ltä.",
                    "links": [
                        {
                            "text": "Lisätietoja täältä: https://www.samsung.com/fi/flex",
                            "url": "https://www.samsung.com/fi/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Tietoja Lisa&stä",
                    "text": "Yrityksen nimi: Lisa & friends AB\nY-tunnus: 559315-0955\nPostiosoite: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden\nALV-numero: SE559315095501\n"
                },
                {
                    "title": "Tietoja Samsungista",
                    "text": "Yrityksen nimi: Samsung Electronics Nordic AB\nY-tunnus: 556445-4345\nYhteystiedot: https://www.samsung.com/fi/support/contact/\nKäyntiosoite: Vaisalantie 4, 02130 Esbo, Soumi\nPostiosoite: Box 1235, 164 28 Kista, Ruotsi\nALV-numero: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "portalFooter": {
            "backToTop": "Takaisin alkuun",
            "copyright": "Asiakasportaalin ja muut Samsung Flexiin liittyvät palvelut tarjoaa Foxway. Copyright© 1995-{{currentYear}} Samsung. Kaikki oikeudet pidätetään.",
            "items": [
                {
                    "title": "Asiakastuki",
                    "links": [
                        {
                            "text": "080 077 31 77",
                            "url": "tel:080 077 31 77"
                        },
                        {
                            "text": "ma-pe | 08:00 - 21:00"
                        },
                        {
                            "text": "la | Suljettu"
                        },
                        {
                            "text": "su | Suljettu"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/fi/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Tietoja Samsung Flexistä",
                    "text": "Lisa& tarjoaa yksityishenkilöille mahdollisuuden vuokrata tuotteita, joita Samsung Electronics Nordic AB tarjoaa Samsung Flex -palvelun puitteissa. Tilauksen yhteydessä asiakas voi myös ostaa tiettyjä muita tuotteita Lisa&:ltä.",
                    "links": [
                        {
                            "text": "Lisätietoja täältä: https://www.samsung.com/fi/flex",
                            "url": "https://www.samsung.com/fi/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Tietoja Lisa&stä",
                    "text": "Yrityksen nimi: Lisa & friends AB\nY-tunnus: 559315-0955\nPostiosoite: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden\nALV-numero: SE559315095501\n"
                },
                {
                    "title": "Tietoja Samsungista",
                    "text": "Yrityksen nimi: Samsung Electronics Nordic AB\nY-tunnus: 556445-4345\nYhteystiedot: https://www.samsung.com/fi/support/contact/\nKäyntiosoite: Vaisalantie 4, 02130 Esbo, Soumi\nPostiosoite: Box 1235, 164 28 Kista, Ruotsi\nALV-numero: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "plans": {
            "tradeInTitle": "Lisäalennus vaihdon jälkeen:",
            "tradeIn": "{{amount}}/kk {{duration}} kuukauden ajan",
            "closeModal": "Sulje",
            "selectSubscription": "Samsung Flex – uusi tapa käyttää Samsung Galaxya",
            "description": "Samsung Flex antaa sinulle mahdollisuuden käyttää Samsung Galaxya omistamatta sitä – aina kiinteällä kuukausimaksulla. Voit valita joko vapauden vaihtaa tai päivittää laitteen uuteen ja lopettaa sopimuksen milloin tahansa, tai vaihtoehdon alhaisemmalla kuukausimaksulla, jolloin sitoudut 36 kuukauden sopimusjaksoon. Kun päivität tai lopetat tilauksesi, Samsung Galaxysi saa uuden elämän tai se kierrätetään. Flex on Samsungin ja Lisa&n yhteistyöhanke, jonka avulla voit vuokrata laitteita Lisa&lta. Lisa& on sopimuskumppanisi Flex-sopimuksessa.",
            "plans": {
                "EMPTY": {
                    "title": "-",
                    "description": "",
                    "descriptionOne": "",
                    "descriptionTwo": "",
                    "descriptionThree": ""
                },
                "FLEX": {
                    "title": "Täysi joustavuus",
                    "description": "",
                    "descriptionOne": {
                        "title": "Vaihda, päivitä ja lopeta milloin haluat",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Pääsy vaihtopalveluun",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "Kiinteä kuukausihinta ",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "Full Flex",
                        "paragraphs": [
                            {
                                "title": "",
                                "content": "Full Flex antaa vapauden valita, milloin haluat vaihtaa tai päivittää laitteesi tai lopettaa tilauksen."
                            },
                            {
                                "title": "Samsung Galaxy kiinteään kuukausihintaan",
                                "content": "Saat kiinteällä kuukausimaksulla käyttöösi valitsemasi Samsung Galaxyn niin pitkäksi aikaa kun haluat."
                            },
                            {
                                "title": "Vaihda tai päivitä milloin haluat",
                                "content": "Full Flex -tilauksella vaihtaminen tai päivittäminen käy helposti. Tilaa ensin uusi Samsung Galaxy samsung.com-verkkosivuilta. Uusi laitteesi toimitetaan kotiisi yhdessä  vanhan laitteesi palauttamiseen käytettävän palautuslomakkeen kanssa. \nSinun ei tarvitse enää koskaan olla ilman Samsung Galaxy -laitettasi."
                            },
                            {
                                "title": "Irtisano milloin haluat",
                                "content": "Full Flex tarjoaa mahdollisuuden irtisanoa palvelu milloin tahansa – maksat vain irtisanomispäivän kalenterikuukauden loppuun.\n\nKun olet päättänyt lopettaa tilauksen, Lisa& lähettää sinulle palautuslomakkeen, jonka avulla voit lähettää laitteen takaisin. Laite on lähetettävä Lisa&lle 14 päivän kuluessa palautuslomakkeen vastaanottamisesta. Mikäli laitetta ei palauteta ilmoitetun ajan kuluessa, palvelun laskutusta jatketaan kunnes Lisa& on vastaanottanut laitteen."
                            },
                            {
                                "title": "Jos laitteesi vahingoittuu",
                                "content": "Samsung Flex -sopimuksen puitteissa tarjotaan Swap Service -palvelua, mikä tarkoittaa, että maksat tahattomien putoamis- ja kosteusvahinkojen yhteydessä rajoitetun vahinkomaksun korvaavasta laitteesta.\n\nIlmoita vahingosta asiakasportaalin kautta. Sen jälkeen Lisa& arvioi, oikeuttaako sattunut vahinko Swap Service -palveluun. Jos vahinkotapaus hyväksytään, Lisa& lähettää sinulle korvaavan laitteen ja vaurioituneen laitteen palautukseen käytettävän palautuspaketin. Vahingoittunut laite on lähetettävä Lisa&lle viimeistään 14 päivän kuluessa siitä, kun olet saanut korvaavan laitteen.\n\nJos laitteesi varastetaan, katoaa tai tuhoutuu muulla tavoin kuin Swap Service -palveluun oikeuttavalla tavalla, olet velvollinen korvaamaan Lisa&lle aiheutuneen vahingon.\n\nLisa& pidättää itsellään oikeuden tarjota kunnostettua korvaavaa laitetta. Ehdot kokonaisuudessaan:  https://resellers.foxway.com/subscriptionterms-fi."
                            },
                            {
                                "title": "Vaihto ja alennus",
                                "content": "Uutena Samsung Flex -asiakkaana voit antaa vanhan puhelimesi vaihdossa. Full Flex -tilauksen kohdalla vaihtoarvo ja mahdolliset lisäalennukset jaetaan 12 kuukauden ajalle (tai pidemmäksi aikaa, jos alennuksen summa on enemmän kuin 12 kuukausimaksua). Alennus siirretään uuteen laitteeseen, kun laite päivitetään tai vaihdetaan."
                            },
                            {
                                "title": "Lisävarusteet",
                                "content": "Samsung Flex -tilauksen yhteydessä voit ostaa lisävarusteita enintään 500 eurolla. Ne ostetaan silloin kumppaniltamme Lisa&lta, ja kustannukset lisätään ensimmäiseen Flex-laskuusi."
                            }
                        ]
                    },
                    "priceDescription": "{{basePrice}} {{months}} kuukauden kuluttua"
                },
                "VALUE": {
                    "title": "{{months}} kuukautta",
                    "descriptionOne": {
                        "title": "Edullisemmat kuukausihinnat sitoutumalla 36 kuukauden määräaikaiseen sopimukseen",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Vaihto tai palautus sopimuskauden lopussa",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "Pääsy vaihtopalveluun",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "{{months}} kuukautta",
                        "paragraphs": [
                            {
                                "title": "",
                                "content": "36 kuukauden määräaikaisella tilauksella saat Samsung Galaxyn edullisempaan hintaan. Voit päivittää tai lopettaa Samsung Flex -tilauksen 36 kuukauden kuluttua tilauksen tekemisestä."
                            },
                            {
                                "title": "Samsung Galaxy kiinteään kuukausihintaan",
                                "content": "Saat kiinteällä kuukausimaksulla käyttöösi valitsemasi Samsung Galaxyn 36 kuukauden ajaksi."
                            },
                            {
                                "title": "Päivitä tai lopeta ja palauta laite 36 kuukauden jälkeen.",
                                "content": "Kun sitova tilausaika lähestyy loppuaan, sinuun otetaan yhteyttä ja sinua pyydetään tekemään valinta. Samsung Flex -tilauksella vaihtaminen tai päivittäminen käy helposti.\nTilaa ensin uusi Samsung Galaxy samsung.com-sivuilta. Uusi laitteesi toimitetaan kotiisi yhdessä  vanhan laitteesi palauttamiseen  käytettävän palautuslomakkeen kanssa.\nPäivittämällä sinun ei tarvitse enää koskaan olla ilman Samsung Galaxy -laitetta.\n\nJos et palauta laitetta ajoissa, Lisa&:lla on oikeus saada korvaus puuttuvasta laitteesta."
                            },
                            {
                                "title": "Jos laitteesi vahingoittuu",
                                "content": "Samsung Flex -sopimuksen puitteissa tarjotaan Swap Service -palvelua, mikä tarkoittaa, että maksat tahattomien putoamis- ja kosteusvahinkojen yhteydessä rajoitetun vahinkomaksun korvaavasta laitteesta.\n\nIlmoita vahingosta asiakasportaalin kautta. Sen jälkeen Lisa& arvioi, oikeuttaako sattunut vahinko Swap Service -palveluun. Jos vahinkotapaus hyväksytään, Lisa& lähettää sinulle korvaavan laitteen ja vaurioituneen laitteen palautukseen käytettävän palautuspaketin. Vahingoittunut laite on lähetettävä Lisa&lle viimeistään 14 päivän kuluessa siitä, kun olet saanut korvaavan laitteen.\n\nJos laitteesi varastetaan, katoaa tai tuhoutuu muulla tavoin kuin Swap Service -palveluun oikeuttavalla tavalla, olet velvollinen korvaamaan Lisa&lle aiheutuneen vahingon.\n\nLisa& pidättää itsellään oikeuden tarjota kunnostettua korvaavaa laitetta. Ehdot kokonaisuudessaan:  https://resellers.foxway.com/subscriptionterms-fi."
                            },
                            {
                                "title": "Vaihto ja alennus",
                                "content": "Uutena Samsung Flex -asiakkaana voit antaa vanhan puhelimesi vaihdossa. 36 kuukauden tilauksella vaihtoarvo ja mahdolliset lisäalennukset jaetaan 36 kuukauden ajalle."
                            },
                            {
                                "title": "Lisävarusteet",
                                "content": "Samsung Flex -tilauksen yhteydessä voit ostaa lisävarusteita enintään 500 eurolla. Ne ostetaan silloin kumppaniltamme Lisa&lta, ja kustannukset lisätään ensimmäiseen Flex-laskuusi."
                            }
                        ]
                    }
                }
            },
            "selected": "Valintasi",
            "select": "Valitse",
            "minimumTotalCost": "Alhaisimmat kokonaiskustannukset\n{{cost}}"
        },
        "sign": {
            "acceptTermsLabel": "Lähettäkää minulle markkinointiviestejä",
            "acceptTerms": "Suostun siihen, että Samsung Electronics Nordic AB lähettää minulle tietoja Samsungin tuotteista ja palveluista. Tietoa henkilötietojen käsittelystä on <1>täällä</1>.",
            "acceptTermsLink": "https://www.samsung.com/fi/info/privacy/",
            "title": "Henkilötiedot",
            "firstName": "Etunimi",
            "lastName": "Sukunimi",
            "email": "Sähköposti",
            "phone": "Puhelinnumero",
            "postalCode": "Postinumero",
            "address": "Osoite",
            "city": "Paikkakunta",
            "errors": {
                "firstName": "Virheellinen etunimi",
                "lastName": "Virheellinen sukunimi",
                "firstNameTooBig": "Merkkien enimmäismäärä 40. Poistathan etunimet ja muut nimet, jotka eivät ole päivittäisessä käytössä.",
                "lastNameTooBig": "Merkkien enimmäismäärä 40. Poistathan etunimet ja muut nimet, jotka eivät ole päivittäisessä käytössä.",
                "email": "Virheellinen sähköpostiosoite",
                "phone": "Väärä puhelinnumero",
                "postalCode": "Väärä postinumero",
                "address": "Väärä osoite",
                "city": "Virheellinen kaupunki"
            },
            "steps": {
                "yourInfo": "Tietosi",
                "sign": "Allekirjoita",
                "confirmation": "Vahvistus"
            },
            "delivery": "Toimitus",
            "differentShippingAddress": "Toimitusosoite on eri kuin laskutusosoite.",
            "deliveryMethods": {
                "fi-hd-parcel-posti-mx": {
                    "name": "Maksuton kotiinkuljetus Postin kanssa",
                    "description": "",
                    "cartTitle": "Maksuton kotiinkuljetus Postin kanssa",
                    "price": "Ilmainen"
                },
                "se-sena-hd-parcel-postnord": {
                    "name": "Hemleverans med Postnord",
                    "description": "Normal leveranstid är 1-5 vardagar, men kan vara längre för vissa postnummer.",
                    "cartTitle": "Hemleverans med Postnord",
                    "price": "Kostnadsfri"
                },
                "no-sena-hd-mxparcel-bring": {
                    "name": "Levering med Bring",
                    "description": "Normal leveringstid  er 1-5 virkedager",
                    "cartTitle": "Levering med Bring",
                    "price": "Gratis"
                },
                "no-sena-hd-parcel-dhl": {
                    "name": "Hjemlevering (pakke) - DHL",
                    "description": "Leveringstid ved hjemlevering (pakke) er 1-5 arbeidsdager. \nYtterligere leveringstid til visse postnumre kan påløpe.\nTransportøren meddeler deg via SMS under transporten med \nanslått leveringsdato og tid.",
                    "cartTitle": "DHL Express hemleverans",
                    "price": "Kostnadsfri"
                },
                "no-sena-pick-up-point": {
                    "name": "Fremsending - Bring",
                    "description": "I hovedsak 1–3 virkedager avhengig av strekning.\n4–5 dager til enkelte destinasjoner. \nE-varsling (sms/e-post) uten tillegg i prisen forutsetter \nat vi har mobilnummer eller e-postadresse. ",
                    "cartTitle": "Bring pickup",
                    "price": "Kostnadsfri"
                },
                "dk-sena-hd-parcel-postnord": {
                    "name": "Hjemmelevering (pakker) - Postnord",
                    "description": "Levering inden for 1-5 hverdage.\nDer kan være længere leveringstid ved levering til visse \npostnumre. \nTransportøren giver dig besked via SMS under transporten med \nanslået leveringsdato og -tidspunkt.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                },
                "fi-sena-hd-parcel-postnord": {
                    "name": "Postnordin toimitus",
                    "description": "Toimitusaika 1-3 päivää.",
                    "cartTitle": "Postnordin toimitus",
                    "price": "Ilmainen"
                }
            }
        },
        "authStep": {
            "title": "Kirjaudu sisään Flex-tilillesi",
            "subtitle": "Kirjaudu sisään Flex-tilillesi  nähdäksesi Flex-laitteesi ja valitaksesi laitteen päivitystä varten tai lisätäksesi laitteen.",
            "authSelect": "Valitse tunnistautumistapa",
            "authenticationMethod": "Todennus tapa",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "pepTerms": "Täten vahvistan, etten ole poliittisesti vaikutusvaltainen henkilö (PEP), enkä ole poliittisesti vaikutusvaltaisen henkilön perheenjäsen tai tunnettu yhteistyökumppani.",
            "loginWith": "Kirjaudu"
        },
        "validationStep": {
            "title": "Luottojen arviointi",
            "subtitle": "Jotta voimme käsitellä hakemuksesi, meidän on tehtävä luottotietojen arviointi. Ole hyvä ja seuraa alla olevia ohjeita jatkaaksesi.",
            "loadingText": "Teemme luottotietojen tarkistuksen, se kestää muutaman minuutin. Odota, niin sinut ohjataan automaattisesti seuraavaan vaiheeseen."
        },
        "creditCheckStep": {
            "title": "Credit check",
            "subtitle": "We need to run a credit check",
            "terms": "I accept that my information will be submitted to <1>lorem ipsum dolor sit</1> for credit check report.",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "personalNumber": "Personal number",
            "errors": {
                "personalNumber": "Invalid personal number"
            }
        },
        "existingSubscriptionStep": {
            "title": "Flex-tilauksesi",
            "description": "Haluatko päivittää olemassa olevan laitteen vai lisätä uuden?",
            "buttonText": "Lisää uusi Flex-laite",
            "infoText": "",
            "flexTitle": "Full Flex (täysi joustavuus)",
            "valueTitle": "36 kuukauden",
            "eligibleFrom": "Voidaan päivittää: <bold>{{date}}</bold>",
            "planMismatchDisclaimer": "Voidaan vain päivittää <bold>{{name}}</bold>",
            "activeFrom": "Aktiivinen alkaen: <bold>{{date}}</bold>",
            "upgrade": "Päivitä",
            "upgradeNotEligible": {
                "date": "Päivitys ei ole vielä mahdollista. Katso päivämäärä, josta alkaen voit päivittää, yllä.",
                "contactSupport": "Päivitys ei ole mahdollista. Ole hyvä ja ota yhteyttä asiakaspalveluun.",
                "pendingUpgrade": "ällä tilauksella on jo allekirjoitettu päivitys.",
                "activeClaim": "Päivitys ei ole mahdollista käynnissä olevan tukiasian vuoksi.",
                "deviceNotReturned": "Päivitys ei ole mahdollista. Odotamme toista laitetta sinulta.",
                "paymentPending": "Tällä tilauksella on jo allekirjoitettu päivitys, jonka maksu on vielä kesken. Voit jatkaa sitä täällä: ",
                "link": "linkki"
            }
        },
        "cart": {
            "disclaimer": "Vaihtoarvo on arvio. Alennus määritetään ja lisätään, kun vaihto on suoritettu loppuun.",
            "tradeInMonthlyEstimate": "Kuukausimaksu vaihdon jälkeen",
            "tradeInTitle": "Samsung Trade-in",
            "tradeInValue": "Vaihtoarvo",
            "tradeInMonthlyDiscount": "Kuukausittainen vaihtoalennus {{duration}} kuukauden ajan",
            "prepayToday": "Tänään maksettava summa",
            "prepay": "Maksa {{months}} kuukausi tänään",
            "discountDuration": "alennus {{months}} kuukautta",
            "includesDiscount": "Sisältää alennuksesi {{discount}}",
            "cart": "Ostoskärry",
            "overview": "Yhteenveto",
            "oneTimeCost": "Kertamaksu",
            "oneTimeCostAccessories": "Kertamaksu - Lisätarvikkeet",
            "seeDetailsBelow": "Katso lisätiedot alla",
            "authentication": "Vahvista",
            "reviewAndSign": "Tarkista ja allekirjoita",
            "continue": "Jatka",
            "paymentMethod": "Maksutapa",
            "invoice": "Lasku",
            "minimumTotalCost": "Alhaisimmat kokonaiskustannukset",
            "monthlyCost": "Kuukausimaksu",
            "monthlyCostWithoutDiscount": "Kuukausimaksu ennen alennusta",
            "generalDiscount": "Alennus",
            "specialPriceTitle": "Ensimmäiset {{specialPriceLength}} kuukautta, sitten {{priceGross}} {{currencyMonthly}}",
            "creditCheck": "Run credit check",
            "fraudProtection": "Odota hetki",
            "emptyText": "Valitse ensin tilaustyyppi.",
            "noticeText": "Lisäämällä maksutapani hyväksyn, että Lisa& voi veloittaa automaattisesti ja etukäteen kaikki Lisa&lta maksettavat kulut."
        },
        "currency": {
            "perMonth": "kk",
            "feeForMonths": "{{fee}} {{months}} kuukauden ajan"
        },
        "errorPages": {
            "accessory": {
                "title": "Lisävarusteiden enimmäiskustannukset ovat ylittyneet.",
                "button": "Takaisin ostoskoriin",
                "content": "<1><2>Samsung Flex -tilauksen yhteydessä voit ostaa muita tuotteita enintään 500 eurolla. Ostoskorissasi on lisävarusteita, jotka ylittävät tämän summan, joten sinun on tilattava ne erikseen käyttäen toista maksutapaa.</2></1>"
            },
            "general": {
                "title": "Jotain meni pieleen",
                "button": "Takaisin ostoskoriin",
                "content": "<1><2>Jokin meni vikaan. ole hyvä ja yritä uudelleen</2></1>"
            },
            "auth": {
                "title": "Jotain meni pieleen",
                "button": "Takaisin ostoskoriin",
                "content": "<1><2>Jokin meni vikaan. ole hyvä ja yritä uudelleen</2></1>"
            },
            "creditCheck": {
                "title": "Luottotietoja ei hyväksytty",
                "button": "Takaisin ostoskoriin",
                "contentFailed": "Hakemuksesi on hylätty, koska se ei täytä rahoituskumppanimme vaatimuksia tämän tuotteen osalta. Lisätietoja varten olet tervetullut ottamaan yhteyttä asiakastukeemme.",
                "contentTryAgain": "Hakemuksesi on hylätty, koska valitsemasi pankki tai tili ei näytä olevan päätilisi. Palaa takaisin ja hae käyttämällä ensisijaista pankkitiliäsi."
            }
        },
        "errors": {
            "generic": "Jokin meni pieleen. Yritä uudelleen",
            "authenticationError": "Luvaton pääsy",
            "nicknameChangeError": "Lempinimessä on oltava 1–40 merkkiä",
            "scrive": {
                "authenticationError": "Jotain meni pieleen todennuksen kanssa. Yritä uudelleen."
            },
            "svea": {
                "general": "",
                "underAge": "",
                "overAge": "",
                "numberOfAllowedSubscriptions": ""
            }
        },
        "portal": {
            "fraudulentCustomer": "Sinulla on maksamattomia laskuja.",
            "payingIssuesCustomer": "Sinulla on maksamattomia laskuja.",
            "dashboard": {
                "title": "Tervetuloa, "
            },
            "invoiceStatus": {
                "due": "Ei maksettu",
                "allPaid": "Maksettu",
                "dueOn": "Eräpäivä: <2>{{date}}</2>.",
                "nextPayment": "Seuraava lasku on maksettava viimeistään: <2>{{date}}</2>.",
                "noNextPayment": "Ei seuraavaa maksua.",
                "button": "Näytä laskut"
            },
            "products": {
                "nickname": "{{firstName}}in laite"
            },
            "invoice": {
                "status": {
                    "outstanding": "Ei maksettu",
                    "partiallyPaid": "Osittain maksettu",
                    "paid": "Kaikki on maksettu",
                    "terminated": "Lopetettu",
                    "unknown": "Tuntematon",
                    "credited": "Hyvitetty"
                }
            },
            "invoices": {
                "title": "Laskut",
                "tableHeader": ["Laskun tunnus", "Kuvaus", "Jakso", "Eräpäivä", "Summa", "Tila"],
                "viewInvoice": "Näytä lasku",
                "viewInvoices": "Näytä laskut",
                "loadMore": "Lataa lisää",
                "accordion": {
                    "title": "Miten tilaan e-laskun?",
                    "text": "1. Kirjaudu verkkopankkiin\n2. Valitse `uusi e-laskuttaja`, vaihtelee pankeittain\n3. Kirjoita hakukenttään Svea Bank AB tai 3237195-7\n4. Valitse listasta laskutusaihe: Svea Bank, Foxway Finance AB\n5. Syötä uusimman laskun viitenumero (16 merkkiä) ja henkilötunnuksesi niille varattuihin kenttiin. Kirjoita henkilötunnuksen kirjain isolla."
                },
                "status": {
                    "outstanding": "Myöhässä",
                    "partiallyPaid": "Osittain maksettu",
                    "paid": "Maksettu",
                    "terminated": "Lopetettu",
                    "unknown": "Hyvitetty"
                },
                "noInvoices": "Ei laskuja"
            },
            "billingAlert": {
                "generic": {
                    "before": "Maksutapasi on päättymässä. ",
                    "link": "Päivitä maksutapa",
                    "after": ""
                },
                "detailed": {
                    "before": "Maksutapasi on päättymässä. Jotta voit käyttää palveluitamme {{dueDate}} jälkeen, ",
                    "link": "päivitä maksutapasi",
                    "after": "."
                }
            }
        },
        "profile": {
            "title": "Tilini",
            "contactInformation": {
                "title": "Yhteystiedot",
                "firstName": "Etunimi",
                "lastName": "Sukunimi",
                "email": "Sähköposti",
                "phone": "Puhelin"
            },
            "billingInformation": {
                "title": "Laskutustiedot",
                "card": "Kortti",
                "expires": "Vanhentuu",
                "updatePaymentMethod": "Päivitä maksutapa",
                "methodUpdateDescription": "Maksutavan päivitys",
                "noInfo": "Laskutustietoja ei ole saatavilla"
            },
            "address": {
                "title": "Osoite",
                "postalCode": "Postinumero",
                "address": "Osoite",
                "city": "Paikkakunta",
                "saveButton": "Tallenna osoite"
            },
            "notificationPreferences": {
                "marketingModal": {
                    "title": "Lähettäkää minulle markkinointiviestejä",
                    "content": "Suostun siihen, että Samsung Electronics Nordic AB lähettää minulle tietoja Samsungin tuotteista ja palveluista.  Tietoa henkilötietojen käsittelystä on <a href=\"https://www.samsung.com/fi/info/privacy/\">täällä</a>"
                },
                "title": "Ilmoitukset",
                "marketingEmails": "Markkinointi",
                "marketingEmailsLabel": "Lähettäkää minulle markkinointiviestejä ja erikoistarjouksia"
            },
            "contactInformationDisclaimer": {
                "title": "Yhteystietosi",
                "card": {
                    "title": "Yhteystietosi",
                    "description": "Yhteystietosi rekisteröitiin tilauksen tekemisen yhteydessä. Ota yhteyttä asiakaspalveluun, jos sinun on päivitettävä tietojasi.\n080 077 31 77",
                    "link": "",
                    "linkUrl": ""
                }
            }
        },
        "offers": {
            "title": "Tarjoukset"
        },
        "upgrade": {
            "title": "Päivitä"
        },
        "faq": {
            "title": "Frequently Asked Questions",
            "items": [
                {
                    "id": "samsung-flex",
                    "label": "What is Samsung Flex",
                    "children": "Samsung Flex is a service for you who would rather have a fixed monthly cost and regularly keep yourself updated instead of buying your Samsung Galaxy separately. Samsung Flex is available in two variants, Full Flexibility which gives you the freedom to change, upgrade or terminate whenever you want or 36 months where you pay a lower monthly cost and have your phone a little longer. Access to swap service applies to both."
                },
                {
                    "id": "samsung-flex-vs-buying",
                    "label": "How is Samsung Flex different from buying a device outright or in installments?",
                    "children": "..."
                }
            ]
        },
        "subscription": {
            "tradeInReimbursement": "Jäljellä olevan vaihtosaldon palautus",
            "flexSubscriptionFee": "Flex-tilausmaksu",
            "depositAndAccessoryPayment": "Talletuksen & tarvikkeet maksaminen",
            "upfrontPayment": "Ensimmäiset {{months}} kuukautta ja lisämaksu",
            "endedDate": "Päättymispäivä: <1></1>",
            "upgradeFrom": "Voidaan päivittää alkaen <1></1>",
            "ended": "Päättyi",
            "contractSigned": "Sopimus allekirjoitettu",
            "contractStarted": "Alkoi",
            "contractEnded": "Päättymispäivä",
            "upgradeAnyTime": "Päivitä milloin haluat",
            "devicesTitle": "Aiemmat laitteeni",
            "flexTitle": "Laitteesi Full Flex -sopimuksella",
            "imeiCopy": "IMEI kopioitu",
            "viewContract": "Avaa sopimus",
            "viewInvoices": "Näytä laskut",
            "manageSubscription": "Hallinnoi laitettani",
            "addNewSubscription": "Lisää uusi laite",
            "addNewSubscriptionLink": "https://shop.samsung.com/fi/",
            "swapService": "Vaihtopalvelu",
            "insuranceService": "Luo vahinkoilmoitus",
            "deviceDamagedConditionTermsLink": "https://resellers.foxway.com/subscriptionterms-fi",
            "deviceDamagedConditionTerms": "<0>Jos laite vaurioituu tai katoaa, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun, jotta saat korvaavan laitteen. Maksu vaihtelee mallista riippuen. Vastaa alla oleviin kysymyksiin asiasi kuvailemiseksi ja saadaksesi Foxwayn arvion siitä, kuuluuko vaurio vaihtopalvelun piiriin. Jos vaurio kuuluu vaihtopalvelun piiriin, Foxway lähettää korvaavan laitteen kotiisi yhdessä palautuspaketin kanssa. Palautuspakettia käytetään vaurioituneen laitteen palauttamiseksi. Ota huomioon, että sinun on palautettava vaurioitunut laite viimeistään 14 päivän sisällä siitä, kun olet saanut korvaavan laitteen. Jos et palauta vaurioitunutta laitetta, Foxway laskuttaa sinua korvaavasta laitteesta sopimuksen mukaisesti. Katso vaihtopalvelun ehdot kokonaisuudessaan <2>täältä</2></0>",
            "subscriptionsTitle": "Omat laitteeni",
            "valueTitle": "Laitteesi 24/36 kk sopimuksella",
            "nickname": {
                "title": "Muuta",
                "nickname": "Nimi",
                "description": "Voit lisätä laitteelle lyhyen kuvauksen. Siten voit erottaa laitteet toisistaan, jos sinulla on niitä useampia. Voit antaa niille minkälaisen nimen tahansa, kuten ”Lassen luuri”."
            },
            "payPendingPayment": "Maksa",
            "pendingPaymentsTitle": "Odottaa",
            "tags": {
                "upgradeTo": "Päivitä laitteeni",
                "upgradeFor": "Päivitä laitteeni",
                "beingDelivered": "Toimitetaan",
                "pendingPayment": "Allekirjoitettu, mutta maksu odottaa"
            },
            "cancel": {
                "title": "Päätä Samsung Flex",
                "bolttech": {
                    "title": "Lopeta Samsung Flex",
                    "deviceDamagedConditionTerms": "<0>Jos laitteesi vahingoittuu tai katoaa, olet vastuussa Lisa&:lle aiheutuneen vahingon korvaamisesta. Samsung Flexiin sisältyy Samsung Care+ -vakuutus, joka kattaa tahattomat pudotus- ja vesivahingot. Tällöin tulee tehdä vahinkoilmoitus. Joissakin muissa vauriotapauksissa voidaan soveltaa Samsungin takuuta.</0><1>Täyttämällä lomakkeen saat apua parhaan ratkaisun löytämiseen ongelmaasi.</1>",
                    "submitButton": "Jatka",
                    "continueButton": "Jatka",
                    "fellAndBrokeNotificationTitle": "Vahinkotyyppisi kuuluu tavallisesti Samsung Care+ -vakuutuksen piiriin.",
                    "fellAndBrokeNotificationContent": "Jatka vahinkoilmoituksen tekemiseen vakuutusyhtiölle.",
                    "stoppedWorkingNotificationTitle": "Ongelmasi ei kuulu vakuutuksen piiriin, mutta se saattaa kuulua takuun piiriin.",
                    "stoppedWorkingNotificationContent": "Ota yhteyttä asiakastukeemme saadaksesi lisätietoja.",
                    "lostOrStolenNotificationTitle": "Laitteen katoaminen ei kuulu vakuutuksen piiriin.",
                    "lostOrStolenNotificationContent": "Ota yhteyttä asiakastukeemme saadaksesi lisätietoja.",
                    "damageSpecTitle": "Lataa kuvat, jotka näyttävät laitteen kunnon.",
                    "specificDamage": {
                        "frontScreen": "Etupuoli",
                        "frontScreenDescription": "Lataa kuva(t), jotka näyttävät laitteen etupuolen ja päänäytön",
                        "backSide": "Taustapuoli",
                        "backSideDescription": "Lataa kuva(t), jotka näyttävät laitteen taustapuolen."
                    }
                },
                "unavailableNotification": {
                    "title": "Peruuta tilauksesi",
                    "content": "Tilaustasi ei voi peruuttaa tällä hetkellä. Ota yhteyttä tukeemme saadaksesi lisätietoja.",
                    "linkText": "",
                    "linkUrl": "",
                    "automaticClaim": "Samsung Flex -tilauksesi on pian päättymässä. Olemme jo aloittaneet automaattisen irtisanomisprosessin, ja sinun pitäisi saada palautuspaketti pian. Haluatko päivittää uuteen laitteeseen? Siirry osoitteeseen Samsung.com ja tilaa uusi laite. Valitse kassalla nykyisen laitteesi päivitys. Jos haluat pitää laitteen, ota yhteyttä asiakastukeemme saadaksesi ostotarjouksen."
                },
                "receipt": {
                    "title": "Vaihtopalvelu asiatunnuksella {{id}} on rekisteröity",
                    "content": "Käynnissä olevan vaihtopalvelun tilan näet Omat laitteet -kohdasta\nKun tapauksesi on käsitelty, sinulle lähetetään korvaava laite yhdessä palautuspakkauksen kanssa. Käytä palautuspakkausta vaurioituneen laitteen palauttamiseksi Foxwaylle, joka huolehtii siitä parhaalla tavalla.\nHuomioithan seuraavat:\n1. Jos mahdollista, palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tili vaurioituneesta laitteesta\n2. Vaurioituneen laitteen on oltava palautettuna 14 päivän sisällä siitä, kun olet saanut korvaavan laitteen. Jos et palauta laitettasi, Foxway voi laskuttaa sinulta korvaavan laitteen markkina-arvoa vastaavan summan.",
                    "button": "Takaisin Aloitussivulle"
                },
                "keepDisclaimerTitle": "Haluan palauttaa laitteeni",
                "keepDisclaimerContent": "Jos haluat pitää laitteesi, sinun tulee ottaa yhteyttä asiakastukeen.",
                "upgradeDisclaimerLink": "Hallinnoi tätä tilausta",
                "upgradeDisclaimerTitle": "Haluatko päivittää uuteen laitteeseen?",
                "upgradeDisclaimerContent": "Jos haluat päivittää laitteesi, sinun on palattava 'hallita tilauksiani' -sivulle.",
                "stateChoice": {
                    "title": "Haluatko säilyttää, palauttaa tai päivittää laitteen?",
                    "returnDevice": "Haluan palauttaa laitteeni",
                    "keepDevice": "Haluan pitää laitteeni",
                    "upgradeDevice": "Haluan päivittää laitteeni"
                },
                "invoicesDisclaimerTitle": "Erääntyvät laskut",
                "invoicesDisclaimerContent": "Sinulla on maksamattomia laskuja, huomioi, että kaikki laskut on maksettava ennen peruutuksen viimeistelyä.",
                "errors": {
                    "frontSideDamageFiles": "Lataa kuva laitteen etuosasta",
                    "backSideDamageFiles": "Lataa kuva laitteen takaosasta"
                },
                "claimStatus": {
                    "pending": "Peruutus lähetetty",
                    "approved": "Peruutus hyväksytty",
                    "declined": "Peruutus hylättiin",
                    "completed": "Peruutus suoritettu",
                    "sent": "Palautuspaketti lähetetty",
                    "waitingForPayment": "On maksamattomia laskuja",
                    "paymentReceived": "Payment received",
                    "deviceReceived": "Laite vastaanotettu",
                    "deviceReceivedDamaged": "Laite vastaanotettu vaurioituneena"
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Haluatko päättää Samsung Flex -sopimuksen?",
                        "action": "Päätä palvelu",
                        "content": [
                            "Voit päättää Full Flex -sopimuksen milloin tahansa. Palvelu päättyy kuluvan kuukauden viimeisenä päivänä irtisanomispäivästä laskien, ja sinä maksat palvelusta jäljellä olevan kuukauden loppuun. Saat kotiisi palautuspakkauksen, jossa sinun tulee palauttaa laitteesi. Sinulla on 14 päivää aikaa palauttaa laitteesi kuukauden päätyttyä.\n\nMuista seuraavat:\n<ul><li> Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteestasi ennen sen lähettämistä.</li><li> Nykyisen Samsung Flex -sopimuksesi käyttämättömät alennukset raukeavat irtisanomishetkellä.</li><li> Jos laite on vaurioitunut, sinun on korvattava Foxwaylle aiheutunut vahinko. Tahattomista pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun.</li><li> Laitteesi laskuttamista jatketaan, jos sitä ei palauteta 14 päivän sisällä sen jälkeen, kun irtisanomishetkellä kuluva kuukausi on päättynyt.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Voit päättää Full Flex -sopimuksen milloin tahansa. Palvelu päättyy kuluvan kuukauden viimeisenä päivänä irtisanomispäivästä laskien, ja sinä maksat palvelusta jäljellä olevan kuukauden loppuun. Saat kotiisi palautuspakkauksen, jossa sinun tulee palauttaa laitteesi. Sinulla on 14 päivää aikaa palauttaa laitteesi kuukauden päätyttyä.\n\nMuista seuraavat:\n<ul><li> Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteestasi ennen sen lähettämistä.</li><li> Nykyisen Samsung Flex -sopimuksesi käyttämättömät alennukset raukeavat irtisanomishetkellä.</li><li>Laite tulee palauttaa hyvässä kunnossa – tavanomainen kuluminen on sallittua. Mikäli laite vahingoittuu, olet vastuussa Lisa&:lle aiheutuneen vahingon korvaamisesta. Palveluun sisältyvä vakuutus kattaa tahattomat pudotus- ja vesivahingot, jolloin vahinkoilmoitus tulee tehdä vakuutusyhtiön arvioitavaksi. Jatka eteenpäin noudattamalla seuraavan vaiheen ohjeita.</li><li> Laitteesi laskuttamista jatketaan, jos sitä ei palauteta 14 päivän sisällä sen jälkeen, kun irtisanomishetkellä kuluva kuukausi on päättynyt.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Näin päätät sopimuksen vaihe vaiheelta",
                        "steps": [
                            "Valitse päättäminen ja noudata ohjeita. Seuraavaksi sinun tulee vastata kysymyksiin laitteesi kunnosta. Kun palvelu on irtisanottu, lähetämme kotiisi palautuspaketin.",
                            "Kun palvelu on irtisanottu, lähetämme kotiisi palautuspaketin.",
                            "Poista kaikki tiedot ja Google-tilisi vanhasta laitteesta.",
                            "Pakkaa vanha laite huolellisesti ja jätä se lähimpään postin toimipisteeseen."
                        ],
                        "eligibleNotificationText": "Jos päätät irtisanoa sopimuksesi ensimmäisten {{days}} päivän aikana, ole yhteydessä Samsungiin."
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Haluatko päättää Samsung Flex -sopimuksen?",
                        "action": "Päätä palvelu",
                        "content": [
                            "{{months}} kuukauden sopimuksella voit joko päättää sopimuksen ja lähettää laitteen takaisin, tai päättää sopimuksen ja maksaa tietyn summan laitteen lunastamiseksi, jos haluat pitää sen sopimuskauden jälkeenkin.\nVoit tehdä valinnan täällä asiakasportaalissa kuukautta ennen sopimuskauden päättymistä. Jos et tee itse aktiivista valintaa, palvelu päättyy automaattisesti ja sinun on palautettava laitteesi. Kun laite on palautettava, Foxway lähettää palautuspaketin sinulle, jonka avulla voit palauttaa laitteesi.\nJos haluat päättää sopimuksen ennenaikaisesti, ota yhteyttä asiakaspalveluun apua varten.\n\nHuomioithan seuraavat:\n<ul><li>Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteesta</li><li>Jos laite on vaurioitunut, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun.</li><li>Jos laitettasi ei palauteta 14 päivän sisällä sopimuskauden päättymisestä, sinulta veloitetaan maksu, jolla Foxwaylle korvataan palauttamatta jäänyt laite.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "{{months}} kuukauden sopimuksella voit valita joko päivittää laitteesi uuteen tai päättää palvelun sopimuskauden lopussa. Jos et tee aktiivista valintaa, palvelu päättyy automaattisesti ja laite on palautettava. Jos et tee itse aktiivista valintaa, palvelu päättyy automaattisesti ja sinun on palautettava laitteesi. Kun laite on palautettava, Foxway lähettää palautuspaketin sinulle, jonka avulla voit palauttaa laitteesi. Jos haluat päättää sopimuksen ennenaikaisesti, ota yhteyttä asiakaspalveluun apua varten. \n\nHuomioithan seuraavat:\n<ul><li>Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteesta</li><li>Laite tulee palauttaa hyvässä kunnossa – tavanomainen kuluminen on sallittua. Mikäli laite vahingoittuu, olet vastuussa Lisa&:lle aiheutuneen vahingon korvaamisesta. Palveluun sisältyvä vakuutus kattaa tahattomat pudotus- ja vesivahingot, jolloin vahinkoilmoitus tulee tehdä vakuutusyhtiön arvioitavaksi. Jatka eteenpäin noudattamalla seuraavan vaiheen ohjeita.</li><li>Jos et palauta laitetta 14 päivän kuluessa sopimuskauden päättymisestä, sinulta veloitetaan korvaus palauttamattomasta laitteesta.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Toimi näin",
                        "steps": [
                            "Valitse sopimuksen päättäminen ja noudata ohjeita. Valinta on mahdollista tehdä kuukausi ennen sopimuskauden päättymistä.",
                            "Jos päätät lopettaa ja palauttaa (tai jos et tee mitään valintaa), sinulle lähetetään palautuspaketti. Ota meihin yhteyttä, jos et ole saanut sitä sopimuskauden päätyttyä. Jos olet päättänyt lunastaa laitteen itsellesi, sinulta veloitetaan maksu seuraavassa laskussa.",
                            "Poista kaikki tiedot ja poista Google-tilisi laitteestasi",
                            "Pakkaa laite huolellisesti ja jätä se lähimpään postin toimipisteeseen"
                        ],
                        "eligibleNotificationText": "Jos päätät irtisanoa sopimuksesi ensimmäisten {{days}} päivän aikana, ole yhteydessä Samsungiin."
                    }
                },
                "disclaimer": {
                    "flex": {
                        "title": "Huomioithan seuraavat, kun lopetat Samsung Flexin Full Flex -sopimuksen:",
                        "content": [
                            "Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteestasi",
                            "Nykyisen Samsung Flex -sopimuksesi käyttämättömät alennukset raukeavat irtisanomishetkellä",
                            "Jos laite on vaurioitunut, varastettu tai kadonnut, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun.",
                            "Laitteesi laskuttamista jatketaan, jos sitä ei palauteta 14 päivän sisällä sen jälkeen, kun irtisanomishetkellä kuluva kuukausi on päättynyt."
                        ],
                        "bolttech": {
                            "content": [
                                "Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteestasi",
                                "Nykyisen Samsung Flex -sopimuksesi käyttämättömät alennukset raukeavat irtisanomishetkellä",
                                "Jos laite on vahingoittunut, varastettu tai kadonnut, olet velvollinen korvaamaan Lisa&:lle aiheutuneen vahingon. Samsung Flex sisältää vakuutuksen, joka kattaa vesivahingot ja tapaturmaiset vauriot. Seuraa ohjeita irtisanomisen viimeistelemiseksi ja vahinkoilmoituksen tekemiseksi, mikäli vahinko kuuluu vakuutuksen piiriin.",
                                "Laitteesi laskuttamista jatketaan, jos sitä ei palauteta 14 päivän sisällä sen jälkeen, kun irtisanomishetkellä kuluva kuukausi on päättynyt."
                            ]
                        }
                    },
                    "value": {
                        "title": "Huomioitahan seuraavat, kun lopetat Samsung Flexin 36 kuukauden sopimuksen:",
                        "content": [
                            "Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteestasi ennen sen lähettämistä",
                            "Jos laite on vaurioitunut tai kadonnut, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat vain rajoitetun vahinkomaksun. Katso ehdot kokonaisuudessaan täältä.",
                            "Jos laitettasi ei palauteta 14 päivän sisällä sopimuskauden päättymisestä, sinulta veloitetaan maksu, jolla Foxwaylle korvataan palauttamatta jäänyt laite."
                        ],
                        "bolttech": {
                            "content": [
                                "Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi laitteestasi ennen sen lähettämistä",
                                "Jos laite on vahingoittunut, varastettu tai kadonnut, olet velvollinen korvaamaan Lisa&:lle aiheutuneen vahingon. Samsung Flex sisältää vakuutuksen, joka kattaa vesivahingot ja tapaturmaiset vauriot. Seuraa ohjeita irtisanomisen viimeistelemiseksi ja vahinkoilmoituksen tekemiseksi, mikäli vahinko kuuluu vakuutuksen piiriin.",
                                "Jos laitettasi ei palauteta 14 päivän sisällä sopimuskauden päättymisestä, sinulta veloitetaan maksu, jolla Foxwaylle korvataan palauttamatta jäänyt laite."
                            ]
                        }
                    }
                },
                "formTitle": "Tarvitsemme lisätietoja ennen päättämistä",
                "conditionChoice": "Onko laite hyvässä kunnossa?",
                "conditionsButton": "Näytä lisää",
                "noDamage": "Kyllä, laite on hyvässä kunnossa ja toimii eikä siinä ole vaurioita. Normaalia kulumista ja kosmeettisia vaurioita, kuten naarmuja, joilla ei ole vaikutusta toiminnallisuuteen, ei pidetä vaurioina.",
                "noDamageDescription": "",
                "hasDamage": "Ei, laite on vaurioitunut tai varastettu tai kadonnut",
                "hasDamageDescription": "",
                "damageTitle": "Kuvaile, mitä laitteellesi on tapahtunut",
                "damageAdditionalTitle": "Ota kuvia vauriosta (etupuoli, takapuoli, avoin yleinen näkymä). Sinua pyydetään lataamaan ne alla.",
                "damageDate": "Milloin vahinko tapahtui?",
                "damageDatePlaceholder": "Valitse päivämäärä",
                "nextMonth": "Ensikuussa",
                "prevMonth": "Edellinen kuukausi",
                "damageDescription": "Kuvaile, mitä laitteellesi on tapahtunut",
                "damageDescriptionPlaceholder": "Kuvaile, mitä laitteellesi on tapahtunut",
                "damageSpecTitle": "Valitse kuvaus, joka vastaa parhaiten vahinkoa. Voit valita myös useita vaihtoehtoja.",
                "termsLabel": "Olen lukenut ja ymmärtänyt yllä olevat tiedot",
                "submitButton": "Vahvista",
                "damageType": {
                    "placeholder": "Valitse vaihtoehto",
                    "fellAndBroke": "Laitteessani on vahingosta aiheutunut putoamis- tai kosteusvaurio",
                    "stoppedWorking": "Laitteeni lakkasi toimimasta tai siinä on muu tekninen vika, joka on aiheutunut ilman ulkoista vaikutusta",
                    "lostOrStolen": "Laitteeni on varastettu tai kadonnut"
                },
                "specificDamage": {
                    "frontScreen": "Näyttövaurio – päänäyttö",
                    "frontScreenDescription": "Päänäytössä (suurin näyttö, jos laitteessa on useita näyttöjä) on yksi tai useampi halkeama (naarmuja ei pidetä vauriona).",
                    "frontScreenAddFile": "Lataa kuvat",
                    "frontScreenFile": "Näyttövaurio – päänäyttö",
                    "frontScreenRemove": "Poista etunäytön kuvat",
                    "backSide": "Vaurio takapuolella ja/tai kehyksessä",
                    "backSideDescription": "Takapuoli ja/tai kehys on haljennut tai vääntynyt. (Naarmuja ei pidetä vaurioina)",
                    "backSideAddFile": "Lataa kuvat",
                    "backSideFile": "Vaurio takapuolella ja/tai kehyksessä",
                    "backSideRemove": "Poista näytön takakuva",
                    "camera": "Vaurioitunut kamera",
                    "cameraDescription": "Kamerassa on halkeama, naarmu tai muu vaurio, joka vaikuttaa sen toimintaan. (Naarmuja tai muita vaurioita, jotka eivät vaikuta kameran toimintaan, ei pidetä vaurioina)",
                    "audio": "Ääniongelma",
                    "audioDescription": "Mikrofoni tai kaiutin ei toimi, äänen vääristymisongelmia",
                    "network": "Verkko-ongelma",
                    "networkDescription": "Laitteessa on ongelmia verkkoyhteyden muodostamisessa",
                    "power": "ON/OFF ongelma",
                    "powerDescription": "Laitetta ei voi kytkeä päälle tai pois päältä",
                    "other": "Muut",
                    "otherDescription": "Laitteessa on toisenlainen vaurio",
                    "otherDescriptionLabel": "Kuvaa vauriot yksityiskohtaisesti",
                    "otherDescriptionPlaceholder": "Kuvaile vahinkoa"
                },
                "notSupportedNotificationTitle": "Varastettuja tai kadonneita laitteita ei voi peruuttaa.",
                "notSupportedNotificationContent": "Ota yhteyttä tukeemme saadaksesi lisätietoja.",
                "warrantyNotificationTitle": "Vaikuttaa siltä, että ongelmasi kuuluu takuun piiriin.",
                "warrantyNotificationContent": "Ota yhteyttä tukeemme saadaksesi lisätietoja.",
                "upsell": {
                    "title": "Oletko varma, että haluat päättää palvelun?",
                    "content": "Jos haluat vaihtaa laitteesi, tarjolla on muitakin vaihtoehtoja.",
                    "options": {
                        "swap-device": "Haluan päivittää laitteeni",
                        "cancel-sub": "Haluan lopettaa palvelun",
                        "upgrade-device": "Haluan ilmoittaa vauriosta ja jatkaa Samsung Flexin käyttöä"
                    },
                    "confirmButton": "Vahvista",
                    "closeButton": "Sulje"
                }
            },
            "upgrade": {
                "unavailableNotification": {
                    "title": "Päivitys ei ole saatavilla.",
                    "content": "Lisätietoja saat ottamalla yhteyttä Samsungin asiakastukeen.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Haluatko päivittää tai vaihtaa uuteen laitteeseen?",
                        "content": [
                            "Full Flexin kanssa voit päivittää laitteen tai vaihtaa laitetta milloin haluat. Valitse uusi laitteesi samsung.com-sivuilla ja tilaa se Samsung Flexillä. Seuraavassa vaiheessa valitse nykyisen Samsung Flex -palvelun päivitys. Kun olet tehnyt tilauksen, solmit uuden Samsung Flex -sopimuksen ja saat uuden laitteesi kotiin toimitettuna yhdessä lähetyslomakkeen kanssa. Lähetyslomaketta käytetään vanhan laitteen lähettämiseksi takaisin. Voit siirtää kaiken sisällön uuteen laitteeseen ennen vanhan laitteen lähettämisestä takaisin. Sinulta veloitetaan uuden laitteen hinta, kun olet vastaanottanut sen.\n\nHuomioithan seuraavat:\n<ul><li>Ennen laitteen lähettämistä takaisin palauta se tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi</li><li>Nykyisen Samsung Flex -sopimuksesi käyttämättömät alennukset raukeavat sopimuksen päivityksen yhteydessä, sillä solmit uuden sopimuksen.Mahdollinen alennus vaihdossa annettavasta laitteesta siirretään sen sijaan uuteen sopimukseesi.</li><li> Jos laite on vaurioitunut, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun.</li><li> Nykyisen laitteesi laskuttamista jatketaan, jos sitä ei palauteta 14 päivän kuluessa uuden laitteen vastaanottamisesta.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Full Flexin kanssa voit päivittää laitteen tai vaihtaa laitetta milloin haluat. Valitse uusi laitteesi samsung.com-sivuilla ja tilaa se Samsung Flexillä. Seuraavassa vaiheessa valitse nykyisen Samsung Flex -palvelun päivitys. Kun olet tehnyt tilauksen, solmit uuden Samsung Flex -sopimuksen ja saat uuden laitteesi kotiin toimitettuna yhdessä lähetyslomakkeen kanssa. Lähetyslomaketta käytetään vanhan laitteen lähettämiseksi takaisin. Voit siirtää kaiken sisällön uuteen laitteeseen ennen vanhan laitteen lähettämisestä takaisin. Sinulta veloitetaan uuden laitteen hinta, kun olet vastaanottanut sen.\n\nHuomioithan seuraavat:\n<ul><li>Ennen laitteen lähettämistä takaisin palauta se tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi</li><li>Nykyisen Samsung Flex -sopimuksesi käyttämättömät alennukset raukeavat sopimuksen päivityksen yhteydessä, sillä solmit uuden sopimuksen.Mahdollinen alennus vaihdossa annettavasta laitteesta siirretään sen sijaan uuteen sopimukseesi.</li><li> Jos laite on vaurioitunut, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun.</li><li> Nykyisen laitteesi laskuttamista jatketaan, jos sitä ei palauteta 14 päivän kuluessa uuden laitteen vastaanottamisesta.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Näin päivität laitteesi vaihe vaiheelta",
                        "steps": [
                            "Valitse ”Päivitä” ja valitse uusi laitteesi samsung.com-sivuilla.",
                            "Lisää Samsung Flex ja siirry kassalle. Valitse uuteen laitteeseesi soveltuvat Samsung Flex -ehdot.",
                            "Kun olet tunnistautunut nykyiseksi asiakkaaksi, sinulta kysytään, haluatko päivittää nykyisen laitteesi. Valitse laite, johon haluat päivittää.",
                            "Saata tilaus päätökseen. Saat uuden laitteesi kotiin toimitettuna yhdessä vanhalle laitteelle tarkoitetun lähetyslomakkeen kanssa.",
                            "Siirrä kaikki sisältö uudelle laitteelle. Poista sen jälkeen kaikki tiedot ja Google-tilisi vanhasta laitteesta.",
                            "Pakkaa vanha laite huolellisesti ja jätä se lähimpään postin toimipisteeseen. Voit käyttää pakkausta, jossa uusi laitteesi lähetettiin."
                        ],
                        "action": "Päivitä",
                        "url": "https://samsung.com"
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Haluatko päivittää uuteen laitteeseen?",
                        "content": [
                            "Onko aika päivittää? {{months}} kuukauden sopimuksella voit päivittää uuteen laitteeseen, kun sopimuskausi on päättynyt. Valitse silloin uusi laitteesi samsung.com-sivuilla ja tilaa se Samsung Flexillä. Seuraavassa vaiheessa valitse olemassa olevan Samsung Flex -palvelun päivitys. Voit päivittää uuteen laitteeseen siitä lähtien, kun nykyistä sopimuskautta on vielä kuukausi jäljellä.\nKun olet tilannut päivityksen, saat uuden laitteesi kotiin toimitettuna yhdessä lähetyslomakkeen kanssa. Lähetyslomaketta käytetään vanhan laitteen lähettämiseksi takaisin. Voit siirtää kaiken sisällön uuteen laitteeseen ennen vanhan laitteen lähettämisestä takaisin.\n\nHuomioithan seuraavat:\n<ul><li> Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi</li><li> Jos laite on vaurioitunut, sinun on korvattava Foxwaylle aiheutunut vahinko. Vahingossa tapahtuneista laitteen pudotus- ja kosteusvaurioista maksat rajoitetun vahinkomaksun.</li><li> Jos laitettasi ei palauteta 14 päivän sisällä sopimuskauden päättymisestä, sinulta veloitetaan maksu, jolla Foxwaylle korvataan palauttamatta jäänyt laite.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Onko aika päivittää? {{months}} kuukauden sopimuksella voit päivittää uuteen laitteeseen, kun sopimuskausi on päättynyt. Valitse silloin uusi laitteesi samsung.com-sivuilla ja tilaa se Samsung Flexillä. Seuraavassa vaiheessa valitse olemassa olevan Samsung Flex -palvelun päivitys. Voit päivittää uuteen laitteeseen siitä lähtien, kun nykyistä sopimuskautta on vielä kuukausi jäljellä.\nKun olet tilannut päivityksen, saat uuden laitteesi kotiin toimitettuna yhdessä lähetyslomakkeen kanssa. Lähetyslomaketta käytetään vanhan laitteen lähettämiseksi takaisin. Voit siirtää kaiken sisällön uuteen laitteeseen ennen vanhan laitteen lähettämisestä takaisin.\n\nHuomioithan seuraavat:\n<ul><li> Palauta laitteesi tehdasasetuksiin, poista kaikki tiedot ja poista Google-tilisi</li><li>Laite tulee palauttaa hyvässä kunnossa – tavanomainen kuluminen on sallittua.\nMikäli laite vahingoittuu, olet vastuussa Lisa&:lle aiheutuneen vahingon korvaamisesta. Palveluun sisältyvä vakuutus kattaa tahattomat pudotus- ja vesivahingot, jolloin vahinkoilmoitus tulee tehdä vakuutusyhtiön arvioitavaksi. Muihin vaurioihin voidaan joissain tapauksissa soveltaa Samsungin takuuta.</li><li> Jos laitettasi ei palauteta 14 päivän sisällä sopimuskauden päättymisestä, sinulta veloitetaan maksu, jolla Foxwaylle korvataan palauttamatta jäänyt laite.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Näin päivität laitteesi vaihe vaiheelta",
                        "steps": [
                            "Tarkista sopimusjaksosi. 36 kuukauden sopimuksella voit tilata päivityksen alkaen siitä ajankohdasta, kun sopimuskauden päättymiseen on kuukausi aikaa.",
                            "Valitse ”Päivitä” ja valitse uusi laitteesi samsung.com-sivuilla.",
                            "Kun olet tunnistautunut nykyiseksi asiakkaaksi, sinulta kysytään, haluatko päivittää nykyisen laitteesi. Valitse laite, jonka haluat päivittää.",
                            "Saata tilaus päätökseen. Saat uuden laitteesi kotiin toimitettuna yhdessä vanhalle laitteelle tarkoitetun lähetyslomakkeen kanssa.",
                            "Siirrä kaikki sisältö uudelle laitteelle. Poista sen jälkeen kaikki tiedot ja Google-tilisi vanhasta laitteesta.",
                            "Pakkaa vanha laite huolellisesti ja jätä se lähimpään postin toimipisteeseen. Voit käyttää pakkausta, jossa uusi laitteesi lähetettiin."
                        ],
                        "action": "Päivitä",
                        "url": "https://samsung.com"
                    }
                }
            },
            "swap": {
                "unavailableNotification": {
                    "title": "Vaihtopalvelu ei ole saatavilla.",
                    "content": "Lisätietoja saat ottamalla yhteyttä Samsungin asiakastukeen.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "receipt": {
                    "title": "Vaihtopalvelu asiatunnuksella {{id}} on rekisteröity",
                    "content": "Kun tapauksesi on käsitelty ja mikäli se hyväksytään, saat laskun Swap-kuluineen. (Jos sinulla on suoraveloitus käytössä,  kulut vähennetään tililtäsi automaattisesti). Heti kun maksu on suoritettu, sinulle lähetetään korvaava laite sekä palautuspakkaus, jonka avulla voit lähettää vahingoittuneen  laitteen takaisin Foxwaylle.",
                    "button": "Takaisin Kotiin"
                },
                "paymentSuccess": {
                    "title": "Swap Service-pyyntö {{id}} on nyt luotu ja maksettu",
                    "content": "Voit tarkastella kaikkia käynnissä olevia Swap-palvelupyyntöjäsi ja niiden tiloja <1>Omat Laitteet -osiossa</1><2>Pyyntösi käsitellään 2 arkipäivän kuluessa.</2>",
                    "button": "Takaisin Kotiin"
                },
                "paymentError": {
                    "title": "Swap Service-pyyntö {{id}} on nyt luotu mutta maksu epäonnistui",
                    "content": "Suorita maksu suorittaaksesi Swap-Service loppuun",
                    "button": "Maksaa"
                },
                "title": "Vaihtopalvelu",
                "bolttech": {
                    "title": "Luo vakuutustapaus",
                    "deviceDamagedConditionTerms": "<0>Jos laitteesi vahingoittuu tai katoaa, olet vastuussa Lisa&:lle aiheutuneen vahingon korvaamisesta. Samsung Flexiin sisältyy Samsung Care+ -vakuutus, joka kattaa tahattomat pudotus- ja vesivahingot. Tällöin tulee tehdä vahinkoilmoitus. Joissakin muissa vauriotapauksissa voidaan soveltaa Samsungin takuuta.</0><1>Täyttämällä lomakkeen saat apua parhaan ratkaisun löytämiseen ongelmaasi.</1>",
                    "submitButton": "Jatka eteenpäin",
                    "continueButton": "Jatka eteenpäin",
                    "fellAndBrokeNotificationTitle": "Vahinkotyyppisi kuuluu tavallisesti Samsung Care+ -vakuutuksen piiriin.",
                    "fellAndBrokeNotificationContent": "Jatka vahinkoilmoituksen tekemiseen vakuutusyhtiölle.",
                    "stoppedWorkingNotificationTitle": "Ongelmasi ei kuulu vakuutuksen piiriin, mutta se saattaa kuulua takuun piiriin.",
                    "stoppedWorkingNotificationContent": "Ota yhteyttä asiakastukeemme saadaksesi lisätietoja.",
                    "lostOrStolenNotificationTitle": "Laitteen katoaminen ei kuulu vakuutuksen piiriin.",
                    "lostOrStolenNotificationContent": "Ota yhteyttä asiakastukeemme saadaksesi lisätietoja."
                },
                "claimStatus": {
                    "pending": "Vaihtopalvelu tarkasteltuna",
                    "approved": "Uusi laite lähetetty",
                    "declined": "Vaihtopalvelu hylätty",
                    "completed": "Valmis",
                    "sent": "Palautuspaketti lähetetty",
                    "waitingForPayment": "On maksamattomia laskuja",
                    "paymentReceived": "Maksu vastaanotettu",
                    "deviceReceived": "Laite vastaanotettu",
                    "deviceReceivedDamaged": "Laite vastaanotettu vaurioituneena"
                },
                "formTitle": "Kuvaile asiasi",
                "submitButton": "Rekisteröi ja maksa",
                "registerButton": "Rekisteröi tapaus",
                "payButton": "Maksaa",
                "continueButton": "Jatka",
                "damageTitle": "Kuvaile, mitä laitteellesi on tapahtunut",
                "damageAdditionalTitle": "Ota kuvia vauriosta (etupuoli, takapuoli, avoin yleinen näkymä). Sinua pyydetään lataamaan ne alla.",
                "damageDate": "Milloin vahinko tapahtui?",
                "damageDatePlaceholder": "Valitse päivämäärä",
                "nextMonth": "Ensikuussa",
                "prevMonth": "Edellinen kuukausi",
                "damageDescription": "Kuvaile, mitä laitteellesi on tapahtunut",
                "damageDescriptionPlaceholder": "Kuvaile, mitä laitteellesi on tapahtunut",
                "damageSpecTitle": "Valitse kuvaus, joka vastaa parhaiten vahinkoa. Voit valita myös useita vaihtoehtoja.",
                "termsLabel": "Olen lukenut ja ymmärtänyt yllä olevat tiedot",
                "summaryTitle": "Vaihtopalvelupyyntö",
                "summary": {
                    "overview": {
                        "issues": {
                            "fell-and-broke": "Laitteessani on vahingosta aiheutunut putoamis- tai kosteusvaurio",
                            "lost": "Laite kadonnut tai varastettu"
                        }
                    },
                    "returnKitSentNotificationTitle": "Huomaa",
                    "returnKitSentNotificationContent": "Lähetämme sinulle palautuspaketin, joka auttaa sinua palauttamaan laitteen.",
                    "returnKitSentNotificationLink": "#",
                    "returnKitSentNotificationLinkText": "",
                    "accordionTitle": "Vaihtopalvelupyyntö",
                    "certificateTitle": "Asiatunnus",
                    "productTitle": "Tuote",
                    "customerTitle": "Asiakkaan nimi",
                    "periodTitle": "Tilauksen alkamispäivä",
                    "deviceDetailsTitle": "Tiedot laitteesta",
                    "overviewTitle": "Yleiskuva tapauksesta",
                    "overviewIssueTitle": "Vaurion tyyppi",
                    "overviewDamageDescriptionTitle": "Kuvaus",
                    "overviewDateTitle": "Vaurion päiväys",
                    "overviewDamagesTitle": "Vauriot",
                    "front-side": "Näyttövaurio – päänäyttö",
                    "back-side": "Vaurio takapuolella ja/tai kehyksessä",
                    "camera": "Vaurioitunut kamera",
                    "audio": "Ääniongelma",
                    "network": "Verkko-ongelma",
                    "on-off-problem": "ON/OFF ongelma",
                    "other": "Muut"
                },
                "notSupportedNotificationTitle": "Vaihtopalvelu ei kata laitteen katoamista, hinta vaihtelee laitteesta riipuen.",
                "notSupportedNotificationContent": "Rekisteröi kadonnut laite saadaksesi Foxwaylta tarjouksen vaihtolaitteesta.",
                "warrantyNotificationTitle": "Vaikuttaa siltä, että ongelmasi kuuluu takuun piiriin.",
                "warrantyNotificationContent": "Ota yhteyttä tukeemme saadaksesi lisätietoja."
            }
        },
        "privacyPolicy": {
            "title": "Eväste- ja tietosuostumuspolitiikka",
            "sections": [
                {
                    "title": "1. Evästeiden käyttö ja tietojen käsittely",
                    "content": "Foxway ja sen kumppanit, mukaan lukien taloudellinen kumppanimme Lisa& Friends AB (rekisteröity Ruotsissa yritysnumerolla 934431650, rekisteröity osoite c/o United Spaces, Drottninggatan 32, 111 51 Tukholma, Ruotsi), käyttävät evästeitä ja vastaavia teknologioita (\"Teknologiat\") tallentaakseen ja päästäkseen tietoihin laitteellasi.\n\nNämä teknologiat ovat välttämättömiä turvallisten ja toimivien palveluiden tarjoamiseksi, mukaan lukien kassaprosessit ja asiakasportaalin toiminnot. Hyväksymällä evästeet suostut tietojesi käsittelyyn, mukaan lukien asiaankuuluvien tietojen jakaminen Lisa& Friends AB:n kanssa taloudellisten palveluiden helpottamiseksi ja saumattoman kokemuksen varmistamiseksi. Löydät lisätietoja tietojen jakamiskäytännöistämme <a href=\"https://www.foxway.com/fi/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">Tietosuojakäytännöstämme</a>."
                },
                {
                    "title": "2. Käyttämämme evästeiden tyypit",
                    "content": "Käytämme sekä välttämättömiä että valinnaisia evästeitä parantaaksemme kokemustasi. Näihin kuuluvat:",
                    "items": [
                        "Ehdottoman välttämättömät evästeet – Tarvitaan verkkosivuston ydintoimintoihin, mukaan lukien turvallisuus ja saavutettavuus.",
                        "Suorituskyky- ja analytiikkaevästeet – Auttaa meitä analysoimaan, miten verkkosivustoamme käytetään käytettävyyden ja suorituskyvyn parantamiseksi.",
                        "Markkinointi- ja mainontaevästeet – Mahdollistavat personoidut mainokset ja markkinointikampanjat, myös kolmansien osapuolten alustoilla."
                    ]
                },
                {
                    "title": "3. Evästeasetustesi hallinta",
                    "content": "Voit hallita evästeasetuksiasi milloin tahansa:",
                    "items": [
                        "Hyväksy kaikki evästeet – Mahdollistaa täyden toiminnallisuuden, mukaan lukien personoitu sisältö ja markkinointi.",
                        "Hylkää ei-välttämättömät evästeet – Sallii vain ehdottoman välttämättömät evästeet.",
                        "Mukauta asetuksia – Säädä tiettyjä evästeasetuksia kategorioiden perusteella."
                    ],
                    "footer": "Voit muuttaa suostumusasetuksiasi milloin tahansa napsauttamalla \"Mukauta evästeitä\" verkkosivustomme alareunassa.\n\nLisätietoja siitä, miten Foxway käsittelee tietojasi, löydät <a href=\"https://www.foxway.com/fi/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">Tietosuojakäytännöstämme</a>."
                }
            ]
        },
        "sessionExpires": {
            "title": "Istunto päättyi",
            "description": "Haluatko jatkaa istuntoa?",
            "continueButtonText": "Jatkaa",
            "cancelButtonText": "Kirjaudu ulos"
        }
    }
}
